import {
  Component,
  OnInit,
  Input,
  QueryList,
  ViewChildren,
  ChangeDetectorRef,
  ElementRef,
} from '@angular/core';
import { CdkStep, CdkStepper } from '@angular/cdk/stepper';
import { Steps } from './stepper.model';
import { AccordionConfiguration } from '../../../../shared/interfaces/accordion.inteface';
import { checkInputsForText } from '../../../../design-system.helper';

@Component({
  selector: 'mp-stepper',
  styleUrls: ['stepper.component.scss'],
  templateUrl: './stepper.component.html',
  providers: [{ provide: CdkStepper, useExisting: StepperComponent }],
})
export class StepperComponent extends CdkStepper implements OnInit {
  public stepperMobileConfig: AccordionConfiguration;
  public selectedStep: CdkStep = null;
  @Input() cdkSteps: Steps[];
  @ViewChildren(CdkStep) steps!: QueryList<CdkStep>;

  constructor(
    private _cdr: ChangeDetectorRef,
    _elementRef: ElementRef<HTMLElement>,
  ) {
    super(null, _cdr, _elementRef);
  }

  ngOnInit(): void {
    const [cdkSteps] = checkInputsForText([this.cdkSteps]);

    this.cdkSteps = cdkSteps;
    this.selectedStep = this.steps.first;
    this.stepperMobileConfig = {
      card: true,
      isHeaderBold: true,
    };
  }

  selectStepByIndex(index: number, step?: CdkStep): void {
    this.selectedIndex = index;
    this.selectedStep = step;
  }
}
